var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_vm._v(" Here Add Your HTML Content..... ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }